var _rect, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStoresLogo3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "#F1F4F3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.6005 27.88H34.1105C32.5205 27.88 31.2305 26.59 31.2305 25V24.88C31.2305 23.29 32.5205 22 34.1105 22H65.6005C67.1905 22 68.4805 23.29 68.4805 24.88V25C68.4805 26.59 67.1905 27.88 65.6005 27.88Z",
    fill: "#DD7C3A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.56 30.59H63.64V27.88H36.07V30.59H33.15C30.86 30.59 29 32.45 29 34.74V74.31C29 76.6 30.86 78.46 33.15 78.46H66.56C68.85 78.46 70.71 76.6 70.71 74.31V34.74C70.71 32.45 68.86 30.59 66.56 30.59Z",
    fill: "#D7513E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M66.56 78.46C68.85 78.46 70.71 76.6 70.71 74.31V37.63C69.85 37.61 68.98 37.68 68.14 37.84C65.29 38.4 62.68 39.78 59.98 40.86C57.28 41.94 54.3 42.72 51.48 42.01C48.24 41.2 45.58 38.52 42.25 38.25C40.33 38.1 38.45 38.78 36.66 39.48C34.87 40.19 33.04 40.95 31.11 40.96C30.4 40.96 29.68 40.84 29 40.59V74.29C29 76.58 30.86 78.44 33.15 78.44H66.56V78.46Z",
    fill: "#2B5B4F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8617 63.72C58.2012 63.72 64.9617 59.601 64.9617 54.52C64.9617 49.439 58.2012 45.32 49.8617 45.32C41.5222 45.32 34.7617 49.439 34.7617 54.52C34.7617 59.601 41.5222 63.72 49.8617 63.72Z",
    fill: "#EABC49"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoresLogo3);
export default __webpack_public_path__ + "static/media/stores-logo-3.50df3c5cb0409bc2e977a91603be4788.svg";
export { ForwardRef as ReactComponent };